import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-blush py-12 sm:py-16" data-id="element-28" data-mp="18709lbyg90fq">
      <div className="mx-auto max-w-5xl px-5" data-id="element-29" data-mp="13cmjnp2k3lig">
        <div className="text-center" data-id="element-30" data-mp="yeuhm2876j0j">
          <SectionTag data-id="element-31" data-mp="ydrv06hwr2qf">🎁 4 Bonos incluidos</SectionTag>
          <h2 className="mt-3 font-display text-2xl font-black text-ink sm:text-4xl" data-id="element-32" data-mp="tfqadh4u2vcu">
            Siempre incluidos con tu MegaPack
          </h2>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-33" data-mp="of3oa3vdia21">
          {BONOS.map(bono => <article key={bono.num} className="flex gap-3.5 rounded-2xl border border-rose/10 bg-white p-5 shadow-sm" data-id="element-34" data-mp="kfuvb185qg7j">
              <span className="font-display text-3xl font-black text-rose/25" data-id="element-35" data-mp="2est5lktuxcuv">{bono.num}</span>
              <div className="flex-1" data-id="element-36" data-mp="29u9fr9c57gx8">
                <div className="flex items-center gap-2" data-id="element-37" data-mp="29vb249ylzpu9">
                  <GiftIcon className="h-4 w-4 shrink-0 text-rose" aria-hidden data-id="element-38" data-mp="qvo2v5odnp8p" />
                  <h3 className="font-display text-base font-bold text-ink sm:text-lg" data-id="element-39" data-mp="qxr0obvrumnz">
                    {bono.title}
                  </h3>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-ink/70" data-id="element-40" data-mp="hwatse4612oi">{bono.desc}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}